"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptDismissible = void 0;
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var inversify_react_1 = require("inversify-react");
exports.PromptDismissible = (0, mobx_react_1.observer)(function (_a) {
    var promptId = _a.promptId, className = _a.className, children = _a.children;
    var inlinePromptsHistoryStore = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore.inlinePromptsHistoryStore;
    if (inlinePromptsHistoryStore === null || inlinePromptsHistoryStore === void 0 ? void 0 : inlinePromptsHistoryStore.hasDismissed(promptId))
        return null;
    return (react_1.default.createElement("div", { className: className }, react_1.default.Children.map(children, function (element) {
        var onDismiss = function () { return inlinePromptsHistoryStore.dismissedPrompt(promptId); };
        return react_1.default.cloneElement(element, __assign(__assign({}, element.props), { onDismiss: onDismiss }));
    })));
});
